export default __webpack_public_path__ + "static/media/tool_item_blue2.c51a1df4.png";